// Sort and filter for the admin "All apps" table, extracted from Admin.jsx so
// the column ordering is unit-tested. The RAM and Disk columns show USAGE, so
// they must sort by usage (memory_mb / disk_mb), not by the quota limit.

export const appSortKey = (col) =>
  ({
    name: (a) => a.name || "",
    owner: (a) => a.owner_email || a.owner_name || "",
    ram: (a) => a.memory_mb || 0,
    disk: (a) => a.disk_mb || 0,
    node: (a) => a.host || "",
  }[col] || ((a) => a.name || ""));

// filterApps narrows to active, deleted, or all apps.
export const filterApps = (apps, filter) =>
  apps.filter((a) => {
    const deleted = a.soft_deleted_at > 0;
    return filter === "all" ? true : filter === "deleted" ? deleted : !deleted;
  });

// sortApps returns a filtered, sorted copy; it never mutates the input.
export const sortApps = (apps, sort, filter) => {
  const key = appSortKey(sort.col);
  const dir = sort.dir === "asc" ? 1 : -1;
  return [...filterApps(apps, filter)].sort((a, b) => {
    const ka = key(a);
    const kb = key(b);
    if (ka < kb) return -1 * dir;
    if (ka > kb) return 1 * dir;
    return 0;
  });
};
